module.exports = __webpack_public_path__ + "62b4b16054a84a16807fb0d87bc03ea3.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/photo_selector/photo_selector_craftsman.png
// module id = 564
// module chunks = 0